
const partiesV2 = [
    {
        label: "ΝΕΑ ΔΗΜΟΚΡΑΤΙΑ",
        color: "#1a6ab2",
        id: 0,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                
            },
        },
    },
    {
        label: "ΣΥΡΙΖΑ",
        color: "#fc5559",
        id: 1,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "ΠΑΣΟΚ - ΚΙΝΑΛ",
        color: "#30c192",
        id: 2,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "ΚΚΕ",
        color: "#ff0e14",
        id: 3,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "ΕΛΛΗΝΙΚΗ ΛΥΣΗ",
        color: "#5235d6",
        id: 4,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "ΜΕΡΑ25",
        color: "#f38268",
        id: 5,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    // {
    //     label: "ΕΘΝΙΚΟ ΚΟΜΜΑ ΕΛΛΗΝΕΣ",
    //     color: "#0a2136",
    //     id: 6,
    //     data: {
    //         evaluation: {
    //             trend: 0,
    //             MAAvg: 0,
    //             MASum: 0,
    //             MAIndex: 0,
    //             percentages: [],
    //             lastDate: "",
    //         },
    //         intention: {
    //             MAAvg: 0,
    //             MASum: 0,
    //             MAIndex: 0,
    //             percentages: [],
    //         },
    //     },
    // },
    {
        label: "ΑΛΛΟ",
        color: "#423174",
        id: 6,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "",
        color: "",
        id: 7,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
];

export default partiesV2;